import { ChangeDetectionStrategy, Component, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';

import { MessageComponent } from '../message/message.component';

@Component({
	styles: [''],
	selector: 'app-order-filter-query',
	templateUrl: './order-filter-query.component.html',
	changeDetection: ChangeDetectionStrategy.OnPush,
})
export class OrderFilterQueryComponent implements OnInit {
	@ViewChild(MessageComponent) message: MessageComponent;
	@Output() hasChange = new EventEmitter<any>();
	@Input() mappedLists = [];

	selectedFilters: any = {};

	ngOnInit() {
		// To Auto Load Data on Start
		// this.emitFilter();
	}

	@Input() loading: boolean = false;
	@Input() queryData: any = {};

	@Input() listOptionsReview: any = {};
	@Input() listOptions: any[] = [];

	emitFilter() {
		this.hasChange.emit(this.selectedFilters);
	}

	resetFilter() {
		Object.getOwnPropertyNames(this.selectedFilters).forEach(field => {
			this.selectedFilters[field] = null;
		});

		this.selectedFilters.first = 0;
		this.selectedFilters.rows = 100;

		this.emitFilter();
	}
}



// WEBPACK FOOTER //
// C:/Users/Emanuel/Documents/EasyCheck/easy-check-front-web/src/app/shared/component/order-filter-query/order-filter-query.component.ts